import { Injectable } from '@angular/core';

export enum FieldType {
    NONE = "NONE",
    ZIP = "ZIP",
    PHONE = "PHONE",
    DOB = "DOB",
    SSN = "SSN",
    TID = "TID",
}

@Injectable()
export class FormatService {
    constructor() { }


    public FormatByType(type: FieldType, input: string) {
        switch (type) {
            case FieldType.ZIP:
                return this.formatZip(input);
            case FieldType.PHONE:
                return this.formatPhone(input);
            case FieldType.DOB:
                return this.formatDOB(input);
            case FieldType.SSN:
                return this.formatSSN(input);
            case FieldType.TID:
                return this.formatTID(input);
            default:
                return input;
        }
    }

    //Methods
    public formatDOB = function (input: string) {
        if (!input) return input;

        input = input.replace(/\D/g, ''); //remove all non-numerals

        var length = input.length;

        if (length < 3) {
            return input;
        }

        var month = input.substr(0, 2);
        var day = input.substr(2, 2);
        var year = input.substr(4, 4);

        var output = month + '/';

        if (day) {
            output += day;
        }

        if (year) {
            output += '/' + year;
        }

        return output;
    }

    public formatPhone = function (input: string) {
        if (!input) return input;

        input = input.replace(/\D/g, ''); //remove all non-numerals

        var length = input.length;

        if (length < 4) {
            return input;
        }

        var area = input.substr(0, 3);
        var exchange = input.substr(3, 3);
        var local = input.substr(6, 4);

        var output = '(' + area + ')';

        if (exchange) {
            output += ' ' + exchange;
        }

        if (local) {
            output += '-' + local;
        }

        return output;
    }

    public formatNumber = function (input: string) {
        if(!input) return input;
  
        input = input.replace(/\D/g, ''); // remove all non-numerals
        return input;
      };
  

    public formatSSN = function (input: string) {
        if (!input) return input;

        input = input.replace(/\D/g, ''); //remove all non-numerals

        var length = input.length;

        if (length < 4) {
            return input;
        }

        var first = input.substr(0, 3);
        var second = input.substr(3, 2);
        var third = input.substr(5, 4);

        var output = first;

        if (second) {
            output += '-' + second;
        }

        if (third) {
            output += '-' + third;
        }

        return output;
    }

    public formatTID = function (input: string) {
        if (!input) return input;

        input = input.replace(/\D/g, ''); //remove all non-numerals

        var length = input.length;

        if (length < 3) {
            return input;
        }

        var first = input.substr(0, 2);
        var second = input.substr(2, 7);

        var output = first;

        if (second) {
            output += '-' + second;
        }

        return output;
    }

    public formatZip = function (input: string) {
        if (!input) return input;
        input = input.replace(/\D/g, ''); //remove all non-numerals
        var length = input.length;
        if (length < 5) { //still before the hyphen
            return input;
        }

        var first = input.substr(0, 5);
        var second = input.substr(5, 9);
        var output = first;

        if (second) {
            output += '-' + second;
        }
        if (output.length > 10) {
            //over 10 max digits
            output = output.substring(0, 10);
        }
        return output;
    }
}
